import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  getAllConditionsList: [],
  getAllConditionsListLoading: false,
  getConditionById: {},
  isLoading: false,
  conditionsDropdown: [],
};

const conditionSlice = createSlice({
  name: 'conditionSlice',
  initialState,
  reducers: {
    getAllConditionsListSlice: (state, { payload }) => {
      state.getAllConditionsList = payload;
    },
    getAllConditionsListLoadingSlice: (state, { payload }) => {
      state.getAllConditionsListLoading = payload;
    },
    getConditionByIdSlice: (state, { payload }) => {
      state.getConditionById = payload;
    },
    superAdminLoadingSlice: (state, { payload }) => {
      state.isLoading = payload;
    },
    getConditionsDropdownSlice: (state, { payload }) => {
      state.conditionsDropdown = payload;
    },
  },
});

const { actions, reducer } = conditionSlice;

export const {
  getAllConditionsListSlice,
  getAllConditionsListLoadingSlice,
  getConditionByIdSlice,
  superAdminLoadingSlice,
  getConditionsDropdownSlice,
} = actions;

export default reducer;
